import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBluaZBjg0E8JUvIvpmosmu1dWsDkRwiFE",
  authDomain: "portfolio-d37b7.firebaseapp.com",
  projectId: "portfolio-d37b7",
  storageBucket: "portfolio-d37b7.appspot.com",
  messagingSenderId: "977540614066",
  appId: "1:977540614066:web:1e93de87075629ad1346ab",
  measurementId: "G-2SKJDJ4J7W"
})

const db = firebaseApp.firestore()

export default db